import * as t from "io-ts";

const LogoCodec = t.type({
  FileName: t.string
});

export const LogoArrayCodec = t.array(LogoCodec);

export type Logo = t.TypeOf<typeof LogoCodec>;

export interface LogoState {
  readonly loading: boolean;
  readonly data: Logo[] | undefined;
  readonly errors?: string;
}

export enum LogoActions {
  FETCH_ALL = "@@terminalLogos/FETCH",
  FETCH_ALL_SUCCESS = "@@terminalLogos/FETCH_SUCCESS",
  FETCH_ALL_ERROR = "@@terminalLogos/FETCH_ERROR"
}
